import { useEffect, useRef } from "react";

export default function useKeydown(key: string, handler?: () => void) {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!handler) {
      return;
    }

    if (!ref.current) {
      return;
    }

    const keydownListener = (e: KeyboardEvent) => {
      if (e.key === key) {
        handler();
      }
    };

    ref.current.addEventListener("keydown", keydownListener);

    return () => ref.current?.removeEventListener("keydown", keydownListener);
  }, [key, handler]);

  return ref;
}
